export default "__VITE_ASSET__CtFdil_E__"